import { html } from 'lit';
import { Book } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-book')
export class PdsIconBook extends PdsIcon {
  @state()
  icon = Book;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
